import { render, staticRenderFns } from "./DpConstructionAgreement.vue?vue&type=template&id=23caf711&scoped=true&"
import script from "./DpConstructionAgreement.vue?vue&type=script&lang=js&"
export * from "./DpConstructionAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23caf711",
  null
  
)

export default component.exports